var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"account__menu-wrap",attrs:{"aria-labelledby":"account-navigation"}},[_c('ul',{staticClass:"account__menu"},[_c('li',{staticClass:"account__menu-item",class:{
        'account__menu-item--active':
          this.$route.name === 'overview' || this.$route.name === 'account',
        'account__menu-item--show': _vm.menuOpen,
      }},[_c('router-link',{staticClass:"account__menu-item-link",attrs:{"to":{ name: 'overview' }},nativeOn:{"click":function($event){return _vm.toggleMenu()}}},[_vm._v("Overview"),_c('font-awesome-icon',{staticClass:"account__menu-item-icon",class:{
            'account__menu-item-icon--active':
              this.$route.name === 'overview' ||
              this.$route.name === 'account',
            'account__menu-item--show': _vm.menuOpen,
          },attrs:{"icon":"caret-down"}})],1)],1),_c('li',{staticClass:"account__menu-item",class:{
        'account__menu-item--active': this.$route.name === 'plan and billing',
        'account__menu-item--show': _vm.menuOpen,
      }},[_c('router-link',{staticClass:"account__menu-item-link",attrs:{"to":{ name: 'plan and billing' }},nativeOn:{"click":function($event){return _vm.toggleMenu()}}},[_vm._v("Plan and Billing"),_c('font-awesome-icon',{staticClass:"account__menu-item-icon",class:{
            'account__menu-item-icon--active':
              this.$route.name === 'plan and billing',
          },attrs:{"icon":"caret-down"}})],1)],1),_c('li',{staticClass:"account__menu-item",class:{
        'account__menu-item--active':
          this.$route.name === 'advanced settings',
        'account__menu-item--show': _vm.menuOpen,
      }},[_c('router-link',{staticClass:"account__menu-item-link",attrs:{"to":{ name: 'advanced settings' }},nativeOn:{"click":function($event){return _vm.toggleMenu()}}},[_vm._v("Advanced Timer Settings"),_c('font-awesome-icon',{staticClass:"account__menu-item-icon",class:{
            'account__menu-item-icon--active':
              this.$route.name === 'advanced settings',
          },attrs:{"icon":"caret-down"}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }